import React, { createContext, useContext } from "react";
import type { PIMProduct } from "../../../types/types.PIM";

export const ProductContext = createContext<PIMProduct | null>(null);

export function ProductProvider({
  product,
  children,
}: {
  product: PIMProduct;
  children: React.ReactNode;
}) {
  return (
    <ProductContext.Provider value={product}>
      {children}
    </ProductContext.Provider>
  );
}

/**
 * Hook for use inside ProductDetailPage tab content where product is always available.
 * Throws if used outside ProductProvider (e.g. before tabs mount).
 */
export function useProductContext(): PIMProduct {
  const product = useContext(ProductContext);
  if (product == null) {
    throw new Error("useProductContext must be used within a ProductProvider");
  }
  return product;
}
